import { render, staticRenderFns } from "./SplashScreenList.vue?vue&type=template&id=6cfc76d8&"
import script from "./SplashScreenList.vue?vue&type=script&lang=js&"
export * from "./SplashScreenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports